import styled from 'styled-components';

export const BadgeContainer = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  height: 50px;
  width: fit-content;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 30px;
  }
`;

export const TextContainer = styled.div``;
